import Roles from '@/sections/roles/summary/roles-page';
import RoleHistory from '@/sections/roles/history/role-history.vue';

export default [
	{
		name: 'roles-history',
		path: '/roles/:changedEntityId/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search,
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			SourceApplication: route.query.SourceApplication || 'VueSupport',
			changedEntityId: parseInt(route.params.changedEntityId),
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 10
		}),
		component: RoleHistory,
		meta: {
			permissions: ['roles.read', 'users.read']
		}
	},
	{
		name: 'roles',
		path: '/roles',
		component: Roles,
		props: route => ({
			count: route.query.count,
			sortBy: 'role',
			sortDirection: 'asc',
			search: route.query.search,
			roleId: route.query.roleId,
			active: route.query.active,
			clientId: route.query.clientId
		}),
		meta: {
			permissions: ['roles.read', 'users.read']
		}
	}
];
